import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './Common/Header';
import Home from './Pages/Home';
import Footer from './Common/Footer';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Course from './Pages/Course';
import Departments from './Pages/Departments';
import FeeStructure from './Pages/FeeStructure';
import Laboratories from './Pages/Laboratories';
import OurFacilities from './Pages/OurFacilities';
import Careers from './Pages/Careers';
import FunctionsEvents from './Pages/FunctionsEvents';
import ExaminationCell from './Pages/ExaminationCell';
import OurManagement from './Pages/OurManagement';
import Administrative from './Pages/Administrative';
import Inquiry from './Common/Inquiry';

function App() {
  return (
    <>
      <BrowserRouter>
          <Header />
          <Inquiry />
          <Routes>
              <Route path='/' element={<Home />}></Route>
              <Route path='/About' element={<About />}></Route>
              <Route path='/Contact' element={<Contact />}></Route>
              <Route path='/Course' element={<Course />}></Route>
              <Route path='/Departments' element={<Departments />}></Route>
              <Route path='/FeeStructure' element={<FeeStructure />}></Route>
              <Route path='/Laboratories' element={<Laboratories />}></Route>
              <Route path='/OurFacilities' element={<OurFacilities />}></Route>
              <Route path='/Careers' element={<Careers />}></Route>
              <Route path='/FunctionsEvents' element={<FunctionsEvents />}></Route>
              <Route path='/ExaminationCell' element={<ExaminationCell />}></Route>
              <Route path='/OurManagement' element={<OurManagement />}></Route>
              <Route path='/Administrative' element={<Administrative />}></Route>
          </Routes>
          <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
